/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateTaskItemAreaDtoCombinationTable } from './CreateOrUpdateTaskItemAreaDtoCombinationTable';
import {
    CreateOrUpdateTaskItemAreaDtoCombinationTableFromJSON,
    CreateOrUpdateTaskItemAreaDtoCombinationTableFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoCombinationTableToJSON,
} from './CreateOrUpdateTaskItemAreaDtoCombinationTable';
import type { TrackItMeasurementParameterFilterDto } from './TrackItMeasurementParameterFilterDto';
import {
    TrackItMeasurementParameterFilterDtoFromJSON,
    TrackItMeasurementParameterFilterDtoFromJSONTyped,
    TrackItMeasurementParameterFilterDtoToJSON,
} from './TrackItMeasurementParameterFilterDto';

/**
 * 
 * @export
 * @interface GetSuggestedTrackItMeasurementParameterFiltersRequestDto
 */
export interface GetSuggestedTrackItMeasurementParameterFiltersRequestDto {
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDtoCombinationTable}
     * @memberof GetSuggestedTrackItMeasurementParameterFiltersRequestDto
     */
    combinationTable?: CreateOrUpdateTaskItemAreaDtoCombinationTable | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuggestedTrackItMeasurementParameterFiltersRequestDto
     */
    taskItemAreaId?: string | null;
    /**
     * 
     * @type {Array<TrackItMeasurementParameterFilterDto>}
     * @memberof GetSuggestedTrackItMeasurementParameterFiltersRequestDto
     */
    previousFilters?: Array<TrackItMeasurementParameterFilterDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuggestedTrackItMeasurementParameterFiltersRequestDto
     */
    $type?: GetSuggestedTrackItMeasurementParameterFiltersRequestDtoTypeEnum;
}


/**
 * @export
 */
export const GetSuggestedTrackItMeasurementParameterFiltersRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoGetSuggestedTrackItMeasurementParameterFiltersRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.GetSuggestedTrackItMeasurementParameterFiltersRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetSuggestedTrackItMeasurementParameterFiltersRequestDtoTypeEnum = typeof GetSuggestedTrackItMeasurementParameterFiltersRequestDtoTypeEnum[keyof typeof GetSuggestedTrackItMeasurementParameterFiltersRequestDtoTypeEnum];



/**
 * Check if a given object implements the GetSuggestedTrackItMeasurementParameterFiltersRequestDto interface.
 */
export function instanceOfGetSuggestedTrackItMeasurementParameterFiltersRequestDto(value?: unknown): value is GetSuggestedTrackItMeasurementParameterFiltersRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetSuggestedTrackItMeasurementParameterFiltersRequestDtoTypeEnum)[0];
}

export function GetSuggestedTrackItMeasurementParameterFiltersRequestDtoFromJSON(json: any): GetSuggestedTrackItMeasurementParameterFiltersRequestDto {
    return GetSuggestedTrackItMeasurementParameterFiltersRequestDtoFromJSONTyped(json, false);
}

export function GetSuggestedTrackItMeasurementParameterFiltersRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSuggestedTrackItMeasurementParameterFiltersRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'combinationTable': json['combinationTable'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoCombinationTableFromJSON(json['combinationTable']),
        'taskItemAreaId': json['taskItemAreaId'] == null ? undefined : json['taskItemAreaId'],
        'previousFilters': json['previousFilters'] == null ? undefined : ((json['previousFilters'] as Array<any>).map(TrackItMeasurementParameterFilterDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetSuggestedTrackItMeasurementParameterFiltersRequestDtoToJSON(value?: GetSuggestedTrackItMeasurementParameterFiltersRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combinationTable': CreateOrUpdateTaskItemAreaDtoCombinationTableToJSON(value['combinationTable']),
        'taskItemAreaId': value['taskItemAreaId'],
        'previousFilters': value['previousFilters'] == null ? undefined : ((value['previousFilters'] as Array<any>).map(TrackItMeasurementParameterFilterDtoToJSON)),
        '$type': value['$type'],
    });
}

